module.exports = __webpack_public_path__ + "img/target.a6284696.svg";